import { render, staticRenderFns } from "./ExamWrongExercise.vue?vue&type=template&id=2b0826b7&"
import script from "./ExamWrongExercise.vue?vue&type=script&lang=js&"
export * from "./ExamWrongExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b0826b7')) {
      api.createRecord('2b0826b7', component.options)
    } else {
      api.reload('2b0826b7', component.options)
    }
    module.hot.accept("./ExamWrongExercise.vue?vue&type=template&id=2b0826b7&", function () {
      api.rerender('2b0826b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/ExamWrongExercise.vue"
export default component.exports